import throttle from 'lodash/throttle';

const tabButtons = document.querySelectorAll(
	'.block-tab-standard-tab > .wp-block-button .wp-block-button__link, .block-tab-standard__mobile-dropdown-link'
);
const tabBlocks = document.querySelectorAll('.block-tab-standard');
const mobileButtons = document.querySelectorAll(
	'.block-tab-standard__mobile-select-button'
);

let previousWidth = window.innerWidth;

const toggleTab = (e) => {
	e.preventDefault();

	const tabBlock = e.currentTarget.closest('.block-tab-standard');

	if (!tabBlock) {
		return;
	}

	let tab = e.currentTarget.closest('.block-tab-standard-tab');

	if (!tab) {
		if (!e.currentTarget.dataset.index) {
			return;
		}

		tab = tabBlock.querySelector(
			`.block-tab-standard-tab[data-index="${e.currentTarget.dataset.index}"]`
		);
	}

	if (!tab) {
		return;
	}

	tabButtons.forEach((tabButton) => {
		if (
			tabButton.classList.contains(
				'block-tab-standard__mobile-dropdown-link'
			)
		) {
			tabButton.classList.remove('active');
		} else {
			tabButton.parentElement.classList.remove('active');
		}
	});

	const index = tab.getAttribute('data-index');

	const activeTabButtons = tabBlock.querySelectorAll(
		`.block-tab-standard-tab[data-index="${index}"] > .wp-block-button, .block-tab-standard__mobile-dropdown-link[data-index="${index}"]`
	);

	activeTabButtons.forEach((activeTabButton) => {
		activeTabButton.classList.add('active');

		if (
			activeTabButton.classList.contains(
				'block-tab-standard__mobile-dropdown-link'
			)
		) {
			const mobileSelectButton = tabBlock.querySelector(
				'.block-tab-standard__mobile-select-button'
			);

			if (!mobileSelectButton) {
				return;
			}

			mobileSelectButton.classList.remove(
				'block-tab-standard__mobile-select-button--open'
			);
			mobileSelectButton.nextElementSibling.setAttribute(
				'aria-expanded',
				'false'
			);
			mobileSelectButton.innerText = activeTabButton.innerText;
		}
	});
};

const clickMobileButton = (e) => {
	if (!e.currentTarget.nextElementSibling) {
		return;
	}

	e.preventDefault();

	if (
		e.currentTarget.classList.contains(
			'block-tab-standard__mobile-select-button--open'
		)
	) {
		e.currentTarget.classList.remove(
			'block-tab-standard__mobile-select-button--open'
		);
		e.currentTarget.nextElementSibling.setAttribute(
			'aria-expanded',
			'false'
		);
	} else {
		e.currentTarget.classList.add(
			'block-tab-standard__mobile-select-button--open'
		);
		e.currentTarget.nextElementSibling.setAttribute(
			'aria-expanded',
			'true'
		);
	}
};

const closeMobileButtons = () => {
	if (previousWidth && previousWidth >= 768 && window.innerWidth >= 768) {
		return;
	} else if (
		previousWidth &&
		previousWidth < 768 &&
		window.innerWidth < 768
	) {
		return;
	}

	mobileButtons.forEach((mobileButton) => {
		if (
			mobileButton.classList.contains(
				'block-tab-standard__mobile-select-button--open'
			)
		) {
			mobileButton.classList.remove(
				'block-tab-standard__mobile-select-button--open'
			);
			mobileButton.nextElementSibling.setAttribute(
				'aria-expanded',
				'false'
			);
		}
	});

	previousWidth = window.innerWidth;
};

tabButtons.forEach((tabButton) => {
	tabButton.addEventListener('click', toggleTab);
});

tabBlocks.forEach((tabBlock) => {
	const tabs = tabBlock.querySelectorAll('.block-tab-standard-tab');

	if (tabs.length) {
		tabs.forEach((tab, index) => {
			const tabButton = tab.querySelector(
				'.block-tab-standard-tab > .wp-block-button'
			);

			if (tabButton) {
				tab.setAttribute('data-index', index);
			}

			tabButton.classList.add('initialized');

			if (0 === index) {
				tabButton.classList.add('active');
			}
		});
	}
});

mobileButtons.forEach((mobileButton) => {
	mobileButton.addEventListener('click', clickMobileButton);
});

window.addEventListener('resize', throttle(closeMobileButtons, 100));
